import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { SentimentFilter } from '../model/contracts'

type SentimentFilterChipsProps = {
  value: SentimentFilter[]
  onChange: (next: SentimentFilter[]) => void
}

const SENTIMENT_OPTIONS: SentimentFilter[] = ['positive', 'neutral', 'negative']

export const SentimentFilterChips = memo(function SentimentFilterChips({
  value,
  onChange,
}: SentimentFilterChipsProps) {
  const { t } = useTranslation('feed')

  const isAllActive = value.length === 0

  const handleAllClick = () => {
    onChange([])
  }

  const handleChipClick = (s: SentimentFilter) => {
    if (value.includes(s)) {
      onChange(value.filter((v) => v !== s))
    } else {
      onChange([...value, s])
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={handleAllClick}
        className={cn(
          'rounded-full border px-3 py-1 text-[13px] font-medium transition-colors',
          isAllActive
            ? 'border-primary/40 bg-primary/10 text-primary'
            : 'border-border bg-muted/40 text-muted-foreground hover:bg-muted/60',
        )}
      >
        {t('sentimentFilter.all')}
      </button>

      {SENTIMENT_OPTIONS.map((s) => {
        const isSelected = value.includes(s)
        return (
          <button
            key={s}
            type="button"
            onClick={() => handleChipClick(s)}
            className={cn(
              'rounded-full border px-3 py-1 text-[13px] font-medium transition-colors',
              isSelected
                ? 'border-primary/40 bg-primary/10 text-primary'
                : 'border-border bg-muted/40 text-muted-foreground hover:bg-muted/60',
            )}
          >
            {t(`sentimentFilter.${s}`)}
          </button>
        )
      })}
    </div>
  )
})
